// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TgJWC","option":"styles_option__1xVD9","selected":"styles_selected__lgKHi"};